// Stage 2 "Dashboard" · agent B — 2.5 billing rate prospective + A-18 (Billing / Over Run, Settings rate card), EN + AR.
// Merged into lib/i18n.js translations (big-file rule).
export const I18N_DS_B = {
  en: {
    dsBilling: {
      appliedRate: "Applied rate",
      rateNotSet: "Rate not set",
      noBudgetSet: "No budget set",
      hoursNoRate: "Hours with no rate",
      hoursNoRateHint: "Listed apart — not costed. Give the person a billing grade with a rate card; entries stored before the rate was kept on them are stamped once by the Founder (Maintenance).",
      noneUnrated: "Every logged hour carries a rate.",
      why: "Why",
      reason: {
        no_rate_on_entry: "entry stored before the rate was kept on it",
        no_grade: "no billing grade",
        no_rate_card: "grade has no rate card",
      },
      rateNote: "Costs use the rate in force when each entry was logged (rate, currency, effective-from stored on the entry). A rate change applies only to entries logged after it; earlier entries keep their rate.",
      breakdownHint: "One row per logged session. Cost = hours × the rate applied to that entry (the rate in force when it was logged).",
      breakdownRate: "Rate",
      breakdownCost: "Cost",
      breakdownNoRate: "Hours with no rate",
      currency: "Currency",
      currencyHint: "Per grade. Empty → the engagement's currency is used when an entry is logged.",
      cardHint: "Firm-managed list of billing grades, their hourly cost rates and the rate's currency. A rate change applies to entries logged from then on; earlier entries keep the rate they were logged at.",
      effectiveFrom: "Rate since",
      foreignCost: "In another currency (not added)",
    },
  },
  ar: {
    dsBilling: {
      appliedRate: "السعر المطبَّق",
      rateNotSet: "السعر غير محدَّد",
      noBudgetSet: "لم تُحدَّد ميزانية",
      hoursNoRate: "ساعات بلا سعر",
      hoursNoRateHint: "مدرجة على حدة — غير مكلَّفة. حدِّد للشخص درجة فوترة لها سعر؛ القيود المخزَّنة قبل حفظ السعر عليها يختمها المؤسِّس مرة واحدة (الصيانة).",
      noneUnrated: "كل ساعة مسجَّلة تحمل سعرًا.",
      why: "السبب",
      reason: {
        no_rate_on_entry: "قيد مخزَّن قبل حفظ السعر عليه",
        no_grade: "لا درجة فوترة",
        no_rate_card: "الدرجة بلا سعر في جدول الأسعار",
      },
      rateNote: "تُحسب التكاليف بالسعر الساري عند تسجيل كل قيد (السعر والعملة وتاريخ السريان محفوظة على القيد). تغيير السعر يسري على القيود المسجَّلة بعده فقط؛ القيود السابقة تحتفظ بسعرها.",
      breakdownHint: "صف لكل جلسة مسجَّلة. التكلفة = الساعات × السعر المطبَّق على ذلك القيد (الساري عند تسجيله).",
      breakdownRate: "السعر",
      breakdownCost: "التكلفة",
      breakdownNoRate: "ساعات بلا سعر",
      currency: "العملة",
      currencyHint: "لكل درجة. إن تُركت فارغة تُستخدم عملة المهمة عند تسجيل القيد.",
      cardHint: "قائمة درجات الفوترة التي يديرها المكتب، وأسعار الساعة لها وعملة السعر. تغيير السعر يسري على القيود المسجَّلة من ذلك الحين؛ القيود السابقة تحتفظ بالسعر الذي سُجِّلت به.",
      effectiveFrom: "السعر منذ",
      foreignCost: "بعملة أخرى (غير مضافة)",
    },
  },
};

export default I18N_DS_B;
